import axios from 'axios'

const LOGIN_TTL_MS = 180 * 24 * 60 * 60 * 1000
const KEY_USER_ID = 'userId'
const KEY_TOKEN = 'authToken'
const KEY_EXPIRES_AT = 'loginExpiresAt'
const KEY_OAUTH_RETRY = 'wechatOAuthRetried'

export const api = axios.create({ baseURL: 'https://hongxapi.dashitongxin.cn/api' })

function now () { return Date.now() }

function renewLoginTtl () {
  localStorage.setItem(KEY_EXPIRES_AT, String(now() + LOGIN_TTL_MS))
}

function isLoginValid () {
  const uid = localStorage.getItem(KEY_USER_ID)
  if (!uid) return false
  const expiresAt = Number(localStorage.getItem(KEY_EXPIRES_AT) || 0)
  if (!expiresAt) {
    renewLoginTtl()
    return true
  }
  return expiresAt > now()
}

export function clearLogin () {
  localStorage.removeItem(KEY_USER_ID)
  localStorage.removeItem(KEY_TOKEN)
  localStorage.removeItem(KEY_EXPIRES_AT)
  localStorage.removeItem('nickname')
  localStorage.removeItem('avatarUrl')
}

api.interceptors.request.use(config => {
  if (isLoginValid()) {
    const token = localStorage.getItem(KEY_TOKEN) || `pcdn-h5-${localStorage.getItem(KEY_USER_ID)}`
    config.headers = config.headers || {}
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

api.interceptors.response.use(
  res => res,
  err => {
    if (err && err.response && err.response.status === 401) clearLogin()
    return Promise.reject(err)
  }
)

export function getUserId () {
  return isLoginValid() ? Number(localStorage.getItem(KEY_USER_ID)) : 1
}

export function hasLogin () {
  return isLoginValid()
}

export function isWechat () {
  return /MicroMessenger/i.test(navigator.userAgent)
}

function persistLogin (user) {
  localStorage.setItem(KEY_USER_ID, user.userId)
  localStorage.setItem(KEY_TOKEN, user.token || `pcdn-h5-${user.userId}-${now()}`)
  localStorage.setItem(KEY_EXPIRES_AT, String(user.expiresAt || (now() + LOGIN_TTL_MS)))
  localStorage.setItem('nickname', user.nickname || '')
  localStorage.setItem('avatarUrl', user.avatarUrl || '')
}

function cleanOAuthUrl () {
  const url = new URL(location.href)
  url.searchParams.delete('code')
  url.searchParams.delete('state')
  return url.toString()
}

async function startWechatOAuth () {
  let appId = localStorage.getItem('wechatAppId') || ''
  if (!appId) {
    const config = (await api.get('/h5/wechat-config')).data.data || {}
    appId = config.appId || ''
    if (appId) localStorage.setItem('wechatAppId', appId)
  }
  if (!appId) throw new Error('微信公众号 AppID 尚未配置')
  const redirect = encodeURIComponent(cleanOAuthUrl())
  location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirect}&response_type=code&scope=snsapi_userinfo&state=pcdn#wechat_redirect`)
  return null
}

export async function ensureLogin () {
  if (isLoginValid()) return Number(localStorage.getItem(KEY_USER_ID))
  clearLogin()
  const params = new URLSearchParams(location.search)
  let code = params.get('code')
  let wxConfig = null
  if (!code && isWechat()) {
    return startWechatOAuth()
  }
  if (!code) {
    if (!wxConfig) wxConfig = (await api.get('/h5/wechat-config')).data.data || {}
    if (!wxConfig.devLoginEnabled) throw new Error(isWechat() ? '服务号登录尚未配置' : '请在微信服务号内打开页面登录')
    code = 'dev-' + now()
  }
  let user
  try {
    user = (await api.get('/h5/wechat-login', { params: { code } })).data.data
  } catch (err) {
    const message = String((err.response && err.response.data && err.response.data.message) || err.message || '')
    const invalidCode = /40029|invalid\s*code/i.test(message)
    if (invalidCode && isWechat() && sessionStorage.getItem(KEY_OAUTH_RETRY) !== '1') {
      sessionStorage.setItem(KEY_OAUTH_RETRY, '1')
      clearLogin()
      return startWechatOAuth()
    }
    sessionStorage.removeItem(KEY_OAUTH_RETRY)
    throw err
  }
  persistLogin(user)
  sessionStorage.removeItem(KEY_OAUTH_RETRY)
  if (params.has('code') || params.has('state')) {
    params.delete('code'); params.delete('state')
    const clean = location.pathname + (params.toString() ? '?' + params.toString() : '') + location.hash
    history.replaceState(null, document.title, clean)
  }
  return Number(user.userId)
}
